import lazyLoading from './lazyLoading'
import DashboardLayout from '@layouts/Dashboard'
import AgencyGuard from './guards/agency-guard'

export default [
  {
    path: '/podcast/',
    component: DashboardLayout,
    beforeEnter: AgencyGuard,
    redirect: { name: 'podcast.campaign.index' },
    children: [
      {
        name: 'podcast.campaign.index',
        path: 'campaigns',
        component: lazyLoading('Podcast/Campaigns/Index'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'podcast.campaign.view',
        path: 'campaign/:id/view',
        component: lazyLoading('Podcast/Campaigns/View'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'podcast.episode.view',
        path: 'episode/:id/view',
        component: lazyLoading('Podcast/Episode'),
        beforeEnter: AgencyGuard,
      },
      {
        name: 'podcast.voices',
        path: 'voices',
        component: lazyLoading('Podcast/Voices'),
        beforeEnter: AgencyGuard,
      },
    ],
  },
]
